<div [matTooltip]="fullName" [matTooltipPosition]="'above'" [class]="'userAvatarContainer ' + size" [ngClass]="{'isAdmin': isAdmin}">
  @if (avatar) {
    <figure class="user-avatar">
      <img [src]="avatar" [alt]="fullName">
    </figure>
  } @else if (!avatar && initials !== '') {
    <div class="user-initials">
      {{initials}}
    </div>
  } @else {
    <figure class="user-avatar text-center">
      <i class="material-icons material-symbols-outlined">
        person
      </i>
    </figure>
  }
</div>
